import React from 'react';
import InfoCard from './InfoCard';
import price from '../../../assets/icons/price.png'
import quality from '../../../assets/icons/quality.png'
import trust from '../../../assets/icons/trust.png'

const InfoCards = () => {
    const CardData = [
        {
            id: 1,
            name: 'Best Price',
            description: 'A trust company is a legal entity that acts as a fiduciary, agent, or trustee on behalf of a person or business for the purpose of administration, management, and the eventual transfer of assets to a beneficial party.',
            icon: price,
        },
        {
            id: 2,
            name: 'Best Quality',
            description: 'When starting a company, most entrepreneurs focus their creative energy on developing an idea and turning it into a sellable product. But before you can begin selling any product or service',
            icon: quality,
            
        },
        {
            id: 3,
            name: 'Trusted',
            description: 'When starting a company, most entrepreneurs focus their creative energy on developing an idea and turning it into a sellable product. But before you can begin selling any product or service',
            icon: trust,
        },
    ]

    return (
        <div className='my-20'>
            <h1 className='text-3xl font-bold text-center text-[#149777]'>Why Choose Us?</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[34px]'>
                {
                    CardData.map(card => <InfoCard
                        key={card.id}
                        card={card}
                    ></InfoCard>)
                }
            </div>
        </div>
    );
};


export default InfoCards;